// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__WD6aZ","header":"Policy_header__p1QJY","images":"Policy_images__ElNHw"};